module.exports = __webpack_public_path__ + "static/media/bussiness.cb045c37.webp";